export default __webpack_public_path__ + "static/media/GalaxyPlanet.550999d2.png";